'use client'

import { Box, Fade, Grid, Stack, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { Trans } from 'react-i18next'
import { useId, useRef } from 'react'
import useOnScreen from '@hooks/useOnScreen'

const RootGrid = styled(Grid, { label: 'Description-rootGrid' })(
  ({ theme }: any) => ({
    height: '100%',
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
  }),
)

const DescriptionTypography = styled(Typography, {
  label: 'DescriptionTypography',
})(({ variant }: any) => ({
  fontSize: variant === 'body1' ? '1.5rem' : '',
  fontWeight: variant === 'body1' ? '300' : '',
}))

const PFPGrid = styled('div', { label: 'PFPGrid' })`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  height: 100%;
  gap: 8px;
`

const PFPImg = styled('img', { label: 'PFPImg' })`
  width: 100%;
  object-fit: cover;
  border-radius: 1rem;
  z-index: 2;
`

function DescriptionPage() {
  const id = useId()
  const root = useRef()
  const isVisible = useOnScreen(root)

  return (
    <Box ref={root}>
      <Fade in={isVisible} timeout={2000}>
        <RootGrid
          container
          spacing={8}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item md={6} sm={12}>
            <PFPGrid>
              {[...Array(16)].map((i, index) => (
                <PFPImg
                  src={`/assets/cats/cat${index}.png`}
                  key={id}
                  alt={`cat-${index}`}
                />
              ))}
            </PFPGrid>
          </Grid>
          <Grid item md={6} sm={12}>
            <Stack spacing={2}>
              <DescriptionTypography variant="h2">
                <Trans i18nKey="descriptionPage.title" />
              </DescriptionTypography>
              <DescriptionTypography
                variant="body1"
                style={{
                  opacity: 0.6,
                }}
                fontFamily="sans-serif"
              >
                <Trans i18nKey="descriptionPage.text" />
              </DescriptionTypography>
            </Stack>
          </Grid>
        </RootGrid>
      </Fade>
    </Box>
  )
}

export default DescriptionPage
